import { gql } from '@apollo/client';
import Fragments from './fragments';

export const INCOME_SOURCE_QUERY = gql`
  query incomeSource($id: Int!) {
    incomeSource(id: $id) {
      ...incomeSourceItem
      details {
        ...incomeSourceDetailItem
        detailValues {
          ...incomeSourceDetailValueItem
        }
      }
    }
  }
  ${Fragments.incomeSourceItem}
  ${Fragments.incomeSourceDetailItem}
  ${Fragments.incomeSourceDetailValueItem}
`;

export const PERIOD_TYPES_QUERY = gql`
  query periodTypes {
    periodTypes {
      id
      code
      name
    }
  }
`;

export const DATA_TYPES_QUERY = gql`
  query dataTypes {
    dataTypes {
      id
      code
      name
    }
  }
`;

export const INCOME_SOURCE_AREAS_QUERY = gql`
  query incomeSourceAreas {
    incomeSourceAreas {
      id
      name
    }
  }
`;
